import React from "react";
import useGlobalHook from "use-global-hook";

import * as actions from "../Actions/CategoryActions";

const initialState = {
    status: 200,
    isLoading: false,
    message: "",
    header: {},
    data: [],
    usersStatus: [],
    lastPage: false,
    type: [],
    module: []
};

const CategoryStore = useGlobalHook(React, initialState, actions);

export default CategoryStore;
